var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMaplyBb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 268.63 64.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #007aff;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3Asset 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.7,37.87,16,23A7.43,7.43,0,0,1,20.93,14L35.07,9.86l13.5-3.44a7,7,0,0,0-8.09-4L15.3,10.6c-3.64,1.11-7.25,5.65-6.1,10.11l3.64,15.15,4.17,15c1.06,3.81,2.36,4.84,6,3.87l1.52-.4A7.09,7.09,0,0,1,24,52.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.9,41,62.23,26.16,58,11.23a7,7,0,0,0-8.43-5.06l-1,.25A7.8,7.8,0,0,1,49,7.54l4.17,15L56.78,37.7a7.42,7.42,0,0,1-4.88,8.88L37.55,50.94l-13,3.4a6.93,6.93,0,0,0,7.8,3.51l14.47-3.69L61,50A7.41,7.41,0,0,0,65.9,41Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.51,54a7.23,7.23,0,0,1-8.71-5.09l-4.28-15L9,19.62,5.27,20.7a7.39,7.39,0,0,0-5,8.94L4,44.5,8.37,59.41A7.22,7.22,0,0,0,17,64.47l14.85-3.69,14.5-4.18a7.38,7.38,0,0,0,5-8.93L51.22,47,40.38,50.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1,36.93,56.36,21.79l-4.27-15a7.23,7.23,0,0,0-8.71-5.1L28.51,5.51,13.79,9.86a7.39,7.39,0,0,0-5,8.87l.22.89,10.76-3.1,14.85-3.68a7.22,7.22,0,0,1,8.65,5.05L47.63,32.8,51.22,47,55.1,45.8A7.38,7.38,0,0,0,60.1,36.93Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M113,31.51V47.93h-9.24V31.18c-.06-3.92-2.46-6-5.12-6s-5.38,1.59-5.38,6.31V47.93H84v-31h9.24v4.52a8.88,8.88,0,0,1,8.11-5.12c4.92,0,8.24,1.86,10,5.45a10.65,10.65,0,0,1,9.31-5.52c7.38,0,12,4.72,12,14.1V47.93h-9.18V31.38c0-4.06-2.39-6.18-5.12-6.18C115.41,25.2,113,27,113,31.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.8,44.41c-2,3-6.65,4.12-9,4.12a15.83,15.83,0,0,1-15.82-16.15,15.84,15.84,0,0,1,15.82-16.16c2,0,6.65.67,9,4.12V16.89H173v31H163.8Zm-7.51-4.65a7.38,7.38,0,1,0,0-14.76c-3.86,0-7.78,2.92-7.78,7.38S152.43,39.76,156.29,39.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.66,16.89v3.85c1.52-2.86,5.25-4.52,9.1-4.52,8,0,15,6.32,15,16.09,0,10-7,16.29-15,16.29-3.85,0-7.58-1.6-9.1-4.46v19h-9.18V16.89Zm7.37,23a7.08,7.08,0,0,0,7.18-7.38A7.1,7.1,0,0,0,198,25a7.23,7.23,0,0,0-7.18,7.51A7,7,0,0,0,198,39.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.74,0V47.93H221.5V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.48,63.16h-9.77l7.45-18.42-12-27.85H245l6.85,17.61,6.91-17.61h9.84Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMaplyBb);
export default __webpack_public_path__ + "static/media/LogoMaply_BB.56dedc010b85cc8740b91f6622582b6f.svg";
export { ForwardRef as ReactComponent };